import { Ease } from "../Ease";
import { Tween } from "./../Tween";
import App from "../App";
import { Container } from "pixi.js";

/**
 * An animated text used in various places to display winnings
 */
class WinValue extends Container {


    valueString: string;
    duration: number;

    constructor(value: any, duration: number) {
        super();
        this.valueString = String(value);
        this.duration = duration;
    }


    create() {
        let xPos = 0;

        for (let letterIdx = 0; letterIdx < this.valueString.length; letterIdx++) {
            let suffix = this.valueString.charAt(letterIdx);
            if (suffix == ".") {
                suffix = "dot";
            }

            let letterSprite = App.assets.getSprite("wpanim_" + suffix);
            letterSprite.anchor.set(.5, .5);
            letterSprite.x = xPos;
            letterSprite.x += letterSprite.width * .5;
            letterSprite.y += letterSprite.height * .5;
            this.addChild(letterSprite);
            xPos += letterSprite.width;
        }

        Tween.to(this, .15, {alpha: 0, delay: this.duration - .15});
        Tween.delayedCall(this.duration, this.parent.removeChild, [this], this.parent);
    }


    playAnimation() {
        for (let childIdx = 0; childIdx < this.children.length; childIdx++) {
            let letterSprite = this.children[childIdx];
            Tween.from(letterSprite.scale, .2, {x: 0, y: 0, delay: childIdx * .06, ease: Ease.BackOut });
        }
    }


}

export default WinValue;